<template>
  <div ref="parent">
    <AppMap
      :viewport="viewport"
      disable-poi-info-windows
      :map-center-position="position"
      :zoom-level="zoomLevel"
      :enable-context-menu="enableContextMenu"
      :fit-within="markers"
      :fit-marker-with-radius="fitMarkerWithRadius"
      :options="mapOptions"
      :geolocation-control="geolocationControl"
      :sidebar-open="showSidebar"
      @click="$emit('click', $event)"
      @zoom-changed="onZoomChange"
      @bounds-changed="$emit('bounds-changed', $event)"
      @viewport-adjustment-to-fit-radius="$emit('viewport-adjustment-to-fit-radius', $event)"
      @location-changed="onLocationChange"
      @current-marker="setCurrentMarker"
      @open-menu="openContextMenu"
      @dragend="onDragEnd"
    >
      <slot />
      <template v-if="currentLocationMarker">
        <AppMapMarker
          class="app-map-current-location-marker"
          :marker="currentLocationMarker"
          has-icon
          :icon-url="defaultCurrentLocationIconUrl"
          :icon-size="iconSize"
          :z-index="1"
        />
      </template>
    </AppMap>
    <context-menu ref="ctxMenu">
      <li>
        <a
          href="#"
          @click="openJobSiteWizard"
        >
          Add job site here
        </a>
      </li>
    </context-menu>
  </div>
</template>

<script>
import contextMenu from 'vue-context-menu';
import { ICON_MARKER_CURRENT_LOCATION } from '~/rails_assets';

export default {
  name: 'JobSitesMap',
  components: {
    contextMenu,
  },
  props: {
    position: {
      type: Object,
      default() {
        return {
          lat: 0,
          lng: 0,
        };
      },
    },
    zoomLevel: {
      type: Number,
      default: 15,
    },
    targetJobSite: Object,
    enableContextMenu: {
      type: Boolean,
      default: false,
    },
    viewport: {
      type: Object,
      default() {
        return null;
      },
    },
    geolocationControl: {
      type: Boolean,
      default: true,
    },
    mapOptions: {
      type: Object,
      default: () => ({}),
    },
    enableClearMapCenter: {
      type: Boolean,
      default: true,
    },
    showSidebar: {
      type: Boolean,
      default: true,
    },
    markers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      lat: 0,
      lng: 0,
      fitMarkerWithRadius: null,
      currentLocationMarker: null,
      defaultIconSize: { width: 15, height: 15 },
      defaultCurrentLocationIconUrl: ICON_MARKER_CURRENT_LOCATION,
    };
  },
  computed: {
    iconSize() {
      if (this.zoomLevel > 13) {
        return {
          width: this.zoomLevel,
          height: this.zoomLevel,
        };
      }

      return this.defaultIconSize;
    },
  },
  watch: {
    targetJobSite(newValue) {
      const jobSite = newValue;

      if (jobSite !== null && ((jobSite.latitude && jobSite.longitude) || jobSite.position)) {
        this.fitMarkerWithRadius = jobSite;

        return;
      }
      this.fitMarkerWithRadius = null;
    },
  },
  methods: {
    onDragEnd() {
      if (this.enableClearMapCenter) {
        this.$store.dispatch('clearMapCenterPosition');
      }
    },
    openContextMenu(e) {
      this.lat = e.latLng.lat();
      this.lng = e.latLng.lng();
      const op = this.$refs.parent.offsetParent;
      const posE = { clientX: e.pixel.x + op.offsetLeft, clientY: e.pixel.y + op.offsetTop };

      // open context menu
      this.$refs.ctxMenu.open(posE);
    },
    openJobSiteWizard() {
      this.$emit('trigger-job-wizard', this.lat, this.lng);
    },
    onZoomChange(zoomLevel) {
      this.$emit('zoom-changed', zoomLevel);
    },
    onLocationChange(position, zoomLevel) {
      this.$emit('center-changed', position);
      this.onZoomChange(zoomLevel);
    },
    setCurrentMarker(position) {
      if (position) {
        this.$emit('set-current-marker', position);
        this.currentLocationMarker = { position };
      } else {
        this.currentLocationMarker = null;
      }
    },
  },
};
</script>
